export default "__VITE_ASSET__BuFwz7p$__"